import { StateUpdater, useCallback } from 'preact/hooks';
import { UICategory, UIService } from '../../contexts/CategoryContext';

export type CategoryProps = {
  category: UICategory;
  checked: boolean;
  onCategoryToggle: () => void;
  onServiceToggle: (service: UIService) => void;
};

type Props = {
  categories: UICategory[];
  setCategories: StateUpdater<UICategory[]>;
};

const MapCategories: (props: Props) => CategoryProps[] = ({ categories, setCategories }) => {
  const getCategoryConsent = useCallback((category: UICategory): boolean => {
    if (category.isEssential) {
      return true;
    }

    return category.services.some((service) => service.consent.status);
  }, []);

  const onCategoryToggleHandler = useCallback(
    (newConsentChecked: boolean, slug: string): void => {
      setCategories(
        categories.map((category) => {
          if (category.slug === slug) {
            return {
              ...category,
              services: category.services.map((temp: UIService) => {
                const updatedService = temp;
                updatedService.consent = {
                  ...temp.consent,
                  status: newConsentChecked,
                };

                return updatedService;
              }),
            };
          }

          return category;
        }),
      );
    },
    [categories, setCategories],
  );

  const onServiceToggle = useCallback(
    (service: UIService): void => {
      setCategories(
        categories.map((category) => {
          return category.services.find((item) => service.id === item.id)
            ? {
                ...category,
                services: category.services.map((temp: UIService) => {
                  if (temp === service) {
                    const updatedService = temp;
                    updatedService.consent = {
                      ...temp.consent,
                      status: !temp.consent.status,
                    };

                    return updatedService;
                  }

                  return temp;
                }),
              }
            : category;
        }),
      );
    },
    [categories, setCategories],
  );

  return categories.map((category) => {
    const checked = getCategoryConsent(category);
    const { slug } = category;
    const onCategoryToggle = (): void => {
      onCategoryToggleHandler(!checked, slug);
    };

    return {
      category,
      checked,
      onCategoryToggle,
      onServiceToggle,
    };
  });
};

export default MapCategories;
